import { AppService } from '@app/app.service';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import Publication from '@app/publication';
import Section from '@app/section';

@Component({
  selector: 'app-edit-section-modal',
  templateUrl: './edit-section-modal.component.html',
  styleUrls: ['./edit-section-modal.component.less'],
})
export class EditSectionModalComponent implements OnInit {
  @Input() close: Function;
  @Input() publication: Publication;
  isLoading = false;
  section: Section = {title: '', sources: []};
  titleCtrl: FormControl = new FormControl('', [Validators.required]);
  constructor(private appService: AppService) { }
  ngOnInit() { }

  submit() {
    if (this.titleCtrl.hasError('required')) {
      return;
    }

    this.isLoading = true;

    this.appService
      .addSection({data: this.section, publicationId: this.publication.id})

      .subscribe(response => {
        this.isLoading = false;
        this.publication.sections.push(response);
        this.close();
      });
  }
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/edit/sections-panel/edit-section-modal/edit-section-modal.component.ts